module.exports = __webpack_public_path__ + "static/default-demolition-clp-d462b1633e160a60cdd5ac81c780c9d7.png";